import { FieldArray } from 'formik';
import { ReactElement } from 'react';
import { MultipassScheduleIndividualFields } from './multipass-schedule-individual-fields';

interface MultipassScheduleIndividualViewProps {
  currentPass: number;
  disabled?: boolean;
  presentingEl?: HTMLElement;
  forceFullScreenModals?: boolean;
}

const MultipassScheduleIndividualView = (
  props: MultipassScheduleIndividualViewProps
): ReactElement => {
  const { currentPass, disabled, presentingEl, forceFullScreenModals } = props;

  return (
    <>
      <div className="multipass-schedule">
        <FieldArray
          name="schedule"
          render={(renderProps) => (
            <MultipassScheduleIndividualFields
              fieldArrayProps={renderProps}
              currentPass={currentPass}
              disabled={disabled}
              presentingEl={presentingEl}
              forceFullScreenModals={forceFullScreenModals}
            />
          )}
        />
      </div>
    </>
  );
};

export { MultipassScheduleIndividualView };
